import { ref } from "vue";
import useCommonChart from "@/mixins/apexChart/commonChart";
import { t } from "@/controllerLK/GlobusLocalization";
import {locales} from "@/mixins/apexChart/locales";

export default function useAreaChart(
  { noDataText },
  categories,
  series,
  hideLegends
) {
  const chartOptions = ref({
    chart: {
      locales,
      defaultLocale: t("all_charts.lang"),
      type: "area",
      offsetY: 5,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        opacityFrom: 0.6,
        opacityTo: 0.2,
      },
    },
    legend: {
      show: !hideLegends,
      fontSize: 14,
    },
    title: {
      text: " ",
      align: "left",
      margin: 20,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#000",
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      "#186AFE",
      "#AB83FF",
      "#FC8DD3",
      "#F9C442",
      "#FA665C",
      "#2E93fA",
      "#66DA26",
      "#546E7A",
      "#E91E63",
      "#FF9800", // Предыдущие цвета взял из макетов Анастасии, а следующие сгененировал чатгтп:
      "#00BCD4", // Бирюзовый
      "#8BC34A", // Светло-зелёный
      "#CDDC39", // Лаймовый
      "#FFEB3B", // Ярко-жёлтый
      "#FFC107", // Оранжевый
      "#9C27B0", // Фиолетовый
      "#673AB7", // Тёмно-фиолетовый
      "#3F51B5", // Индиго
      "#795548", // Коричневый
      "#607D8B", // Синий серый
    ],
    stroke: {
      width: 3,
      hover: {
        filter: {
          type: "darken",
          value: 0.1
        }
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      x: {
        format: "dd MMM yyyy"
      }
    },
    markers: {
      size: 3,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      type: "datetime",
      categories: categories,
      labels: {
        format: "dd.MM.yyyy",
        style: {
          colors: "#878787",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          if (Array.isArray(series?.value) && series.value.length < 1) {
            return "";
          }
          return val;
        },
        style: {
          colors: "#878787",
        },
      },
    },
    grid: {
      borderColor: "#f1f1f1",
      padding: {
        bottom: hideLegends ? 0 : 25,
      },
    },
    noData: {
      text: noDataText ? noDataText : t("all_charts.loading"),
    },
  });

  useCommonChart(chartOptions, categories, series);

  return {
    chartOptions,
  };
}
